import { gql } from '@apollo/client';

export const ACCOUNT_ORDERS_FIELDS_FRAGMENT = gql`
  fragment AccountOrderFields on orders {
    restaurant_desired_delivery_time
    status
    supplier_accepted_delivery_time
    uuid
    order_invoices(limit: 1, order_by: { invoice_date: desc }) {
      invoice_date
      uuid
    }
  }

  fragment AccountOrdersFields on chats {
    placed_orders: orders(
      limit: 1
      order_by: { placed_at: desc }
      where: {
        placed_at: { _is_null: false }
        status: { _nin: $unplacedOrderStatuses }
      }
    ) {
      ...AccountOrderFields
    }
    unplaced_orders: orders(
      limit: 1
      where: { status: { _in: $unplacedOrderStatuses } }
    ) {
      ...AccountOrderFields
    }
  }
`;
